import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "maxLength", "tolerance", "showMoreLabel", "showLessLabel"];
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextLink from 'components/TextLink';
import UserGeneratedText from 'components/UserGeneratedText';
function getLineBreakPosition(content) {
  var lineBreakIndex = content.indexOf('\n');
  if (lineBreakIndex === -1) return Infinity;
  return lineBreakIndex;
}
function ViewMoreText(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var content = props.content,
    maxLength = props.maxLength,
    _props$tolerance = props.tolerance,
    tolerance = _props$tolerance === void 0 ? 30 : _props$tolerance,
    _props$showMoreLabel = props.showMoreLabel,
    showMoreLabel = _props$showMoreLabel === void 0 ? t('actions_show_more') : _props$showMoreLabel,
    _props$showLessLabel = props.showLessLabel,
    showLessLabel = _props$showLessLabel === void 0 ? t('actions_show_less') : _props$showLessLabel,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showFullText = _useState2[0],
    setShowFullText = _useState2[1];
  function toggleShowMore() {
    setShowFullText(function (prevState) {
      return !prevState;
    });
  }
  var contentLength = (content === null || content === void 0 ? void 0 : content.length) || 0;
  var maxLengthBeforeLineBreak = Math.min(maxLength, getLineBreakPosition(content));
  var shouldTextBeTruncated = contentLength > maxLengthBeforeLineBreak + tolerance;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: content,
    truncateLength: !showFullText ? maxLengthBeforeLineBreak : 0,
    allowLineBreaks: !shouldTextBeTruncated || showFullText
  }), ' ', shouldTextBeTruncated && /*#__PURE__*/React.createElement(TextLink, _extends({}, otherProps, {
    as: "button",
    onClick: toggleShowMore
  }), showFullText ? showLessLabel : showMoreLabel));
}
export default ViewMoreText;